import React, { useEffect, useState } from "react";
import { listMySchools, listStaff, getMyPayroll, getPayrollForStaff } from "./happyschoolApi";
import { getActiveSchoolId } from "./activeSchool";

// Lương của tôi: mỗi user chỉ xem được lương khớp đúng tên hồ sơ Nhân sự đã
// liên kết với tài khoản của mình. Owner/admin có thêm ô chọn 1 người khác để
// xem lương thay (tra cứu/hỗ trợ), không phải để xem lén qua tài khoản người khác.

const fmtMoney = (n) => (Number(n) || 0).toLocaleString("vi-VN");

const HappySchoolMyPayroll = () => {
  const schoolId = getActiveSchoolId();
  const [isOwnerAdmin, setIsOwnerAdmin] = useState(false);
  const [allStaff, setAllStaff] = useState([]);
  const [viewStaffId, setViewStaffId] = useState(""); // "" = xem của chính mình
  const [data, setData] = useState(null); // { name, batches }
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState("");

  useEffect(() => {
    if (!schoolId) return;
    listMySchools()
      .then((l) => {
        const s = (l || []).find((x) => x.id === schoolId);
        const admin = !!s && (s.role === "owner" || s.role === "admin");
        setIsOwnerAdmin(admin);
        if (admin) listStaff(schoolId, {}).then((list) => setAllStaff(list || [])).catch(() => {});
      })
      .catch(() => {});
  }, [schoolId]);

  useEffect(() => {
    if (!schoolId) return;
    setLoading(true);
    setError("");
    const req = viewStaffId ? getPayrollForStaff(schoolId, viewStaffId) : getMyPayroll(schoolId);
    req
      .then(setData)
      .catch((e) => setError(e.message))
      .finally(() => setLoading(false));
  }, [schoolId, viewStaffId]);

  if (!schoolId) return <p style={{ color: "#6b7280" }}>Chưa chọn trường.</p>;

  const sortedStaff = allStaff.slice().sort((a, b) => a.name.localeCompare(b.name, "vi"));
  // "Đối chiếu" (Thực lĩnh/Hoàn về) chỉ diễn giải lại PCT+QTKD, không tính
  // vào tổng — "Hoàn về" là tiền về trường, không phải lương nhận thêm.
  const isPayment = (r) => r.source !== "Đối chiếu";
  const grandTotal = data
    ? data.batches.reduce((s, b) => s + b.rows.filter(isPayment).reduce((s2, r) => s2 + (Number(r.amount) || 0), 0), 0)
    : 0;

  return (
    <div style={{ maxWidth: 820, margin: "0 auto" }}>
      <h2 style={{ margin: "0 0 4px" }}>💵 Lương của tôi</h2>
      <p style={{ color: "#6b7280", fontSize: 13, marginTop: 0 }}>
        Chỉ hiện đúng các dòng lương khớp tên hồ sơ Nhân sự đã liên kết với tài khoản của bạn.
      </p>

      {isOwnerAdmin && (
        <div style={{ display: "flex", alignItems: "center", gap: 8, marginBottom: 14, padding: 10, background: "#fffbeb", border: "1px solid #fde68a", borderRadius: 8 }}>
          <span style={{ fontSize: 13, fontWeight: 600, color: "#92400e" }}>Owner/Admin — xem thay:</span>
          <select value={viewStaffId} onChange={(e) => setViewStaffId(e.target.value)} style={sel}>
            <option value="">— Lương của chính tôi —</option>
            {sortedStaff.map((s) => (<option key={s.id} value={s.id}>{s.name}{s.department ? ` (${s.department})` : ""}</option>))}
          </select>
        </div>
      )}

      {error && <p style={{ color: "#dc2626" }}>{error}</p>}
      {loading ? (
        <p>Đang tải...</p>
      ) : !data ? null : (
        <>
          <p style={{ fontSize: 14, marginBottom: 12 }}>
            Đang xem lương của: <b>{data.name}</b>
          </p>
          {data.batches.length === 0 ? (
            <p style={{ color: "#6b7280" }}>Chưa có dữ liệu lương nào khớp tên này.</p>
          ) : (
            <>
              {data.batches.map((b) => {
                const payRows = b.rows.filter(isPayment);
                const reconcileRows = b.rows.filter((r) => !isPayment(r));
                const batchTotal = payRows.reduce((s, r) => s + (Number(r.amount) || 0), 0);
                return (
                  <div key={b.batchId} style={{ marginBottom: 18 }}>
                    <h3 style={{ fontSize: 15, margin: "0 0 8px" }}>{b.batchName}</h3>
                    <div style={{ overflowX: "auto", border: "1px solid #e5e7eb", borderRadius: 8 }}>
                      <table style={{ borderCollapse: "collapse", fontSize: 13, width: "100%" }}>
                        <thead>
                          <tr>
                            <th style={th}>Nguồn</th>
                            <th style={th}>Số tiền</th>
                            <th style={th}>Số tài khoản</th>
                            <th style={th}>Ngân hàng</th>
                            <th style={{ ...th, textAlign: "left" }}>Nội dung</th>
                            <th style={{ ...th, textAlign: "left" }}>Ghi chú</th>
                          </tr>
                        </thead>
                        <tbody>
                          {payRows.map((r, i) => (
                            <tr key={i}>
                              <td style={td}>{r.source}</td>
                              <td style={{ ...td, fontWeight: 600 }}>{fmtMoney(r.amount)}</td>
                              <td style={td}>{r.account}</td>
                              <td style={td}>{r.bank}</td>
                              <td style={{ ...td, textAlign: "left" }}>{r.content}</td>
                              <td style={{ ...td, textAlign: "left" }}>{r.note}</td>
                            </tr>
                          ))}
                          <tr>
                            <td style={{ ...td, fontWeight: 700 }} colSpan={1}>Tổng đợt</td>
                            <td style={{ ...td, fontWeight: 700, background: "#ecfdf5" }}>{fmtMoney(batchTotal)}</td>
                            <td style={td} colSpan={4}></td>
                          </tr>
                        </tbody>
                      </table>
                    </div>

                    {reconcileRows.length > 0 && (
                      <div style={{ marginTop: 10 }}>
                        <div style={{ fontSize: 13, fontWeight: 600, color: "#92400e", marginBottom: 6 }}>↩️ Hoàn về / Đối chiếu</div>
                        <div style={{ overflowX: "auto", border: "1px solid #fde68a", borderRadius: 8 }}>
                          <table style={{ borderCollapse: "collapse", fontSize: 13, width: "100%" }}>
                            <thead>
                              <tr>
                                <th style={{ ...th, background: "#fffbeb" }}>Số tiền</th>
                                <th style={{ ...th, background: "#fffbeb", textAlign: "left" }}>Nội dung</th>
                              </tr>
                            </thead>
                            <tbody>
                              {reconcileRows.map((r, i) => (
                                <tr key={i}>
                                  <td style={{ ...td, fontWeight: 600 }}>{fmtMoney(r.amount)}</td>
                                  <td style={{ ...td, textAlign: "left" }}>{r.content}</td>
                                </tr>
                              ))}
                            </tbody>
                          </table>
                        </div>
                        <p style={{ fontSize: 11, color: "#92400e", margin: "4px 0 0" }}>* Không tính vào Tổng đợt/Tổng cộng — chỉ diễn giải lại số đã có ở trên.</p>
                      </div>
                    )}
                  </div>
                );
              })}
              <div style={{ ...statBox, background: "#ecfdf5", display: "inline-block" }}>Tổng cộng tất cả đợt: <b>{fmtMoney(grandTotal)}</b> đ</div>
            </>
          )}
        </>
      )}
    </div>
  );
};

const statBox = { padding: "8px 14px", border: "1px solid #e5e7eb", borderRadius: 8, fontSize: 13 };
const th = { border: "1px solid #e5e7eb", padding: "6px 8px", background: "#f9fafb", whiteSpace: "nowrap", textAlign: "center" };
const td = { border: "1px solid #e5e7eb", padding: "6px 8px", textAlign: "center" };
const sel = { padding: 8, border: "1px solid #d1d5db", borderRadius: 6, fontSize: 13, background: "#fff" };

export default HappySchoolMyPayroll;
